module.exports = __webpack_public_path__ + "static/media/bg.88b54e1e.png";